/**
 * floor slice: 발언권 관리
 * wehago-conference의 redux/modules/floor 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface FloorState {
  /** 발언권 제어 모드 활성 여부 (마스터가 켜야 참여자 발언권 요청 가능) */
  isEnabled: boolean;
  // 발언권 요청 대기 중인 참여자 ID 목록
  requestList: string[];
  // 발언권 허가된 참여자 ID 목록
  grantList: string[];
  // 내가 발언권 요청 중인지
  isRequesting: boolean;
  // 내가 발언권 보유 중인지
  isGranted: boolean;
}

const initialState: FloorState = {
  isEnabled: false,
  requestList: [],
  grantList: [],
  isRequesting: false,
  isGranted: false,
};

const floorSlice = createSlice({
  name: 'floor',
  initialState,
  reducers: {
    setEnabled(state, action: PayloadAction<boolean>) {
      state.isEnabled = action.payload;
    },

    setRequestList(state, action: PayloadAction<string[]>) {
      state.requestList = action.payload;
    },

    setGrantList(state, action: PayloadAction<string[]>) {
      state.grantList = action.payload;
    },

    addRequest(state, action: PayloadAction<string>) {
      if (!state.requestList.includes(action.payload)) {
        state.requestList.push(action.payload);
      }
    },

    removeRequest(state, action: PayloadAction<string>) {
      state.requestList = state.requestList.filter((id) => id !== action.payload);
    },

    addGrant(state, action: PayloadAction<string>) {
      if (!state.grantList.includes(action.payload)) {
        state.grantList.push(action.payload);
      }
    },

    removeGrant(state, action: PayloadAction<string>) {
      state.grantList = state.grantList.filter((id) => id !== action.payload);
    },

    setRequesting(state, action: PayloadAction<boolean>) {
      state.isRequesting = action.payload;
    },

    setGranted(state, action: PayloadAction<boolean>) {
      state.isGranted = action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const floorActions = floorSlice.actions;
export default floorSlice.reducer;
